import {
  Checkbox as RACCheckbox,
  CheckboxGroup as RACCheckboxGroup,
  type CheckboxGroupProps as RACCheckboxGroupProps,
  type CheckboxProps as RACCheckboxProps,
} from "react-aria-components";

export interface CheckboxGroupProps extends RACCheckboxGroupProps {}
export interface CheckboxProps extends RACCheckboxProps {}

export function CheckboxGroup(props: CheckboxGroupProps) {
  return <RACCheckboxGroup {...props} />;
}

export function Checkbox(props: CheckboxProps) {
  return <RACCheckbox {...props} />;
}
